import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';


import AdviceSection from '../common/AdviceSection';
import SelectFilters from '../common/select-filters/SelectFilters';
import Cards from '../common/cards/Cards';
import Pagination from '../common/pagination/Pagination';
import Methodology from '../common/Methodology';

import { getOSHData } from '../../api';

const Organisations = props => {

    const [pageOfItems, setPageOfItems] = useState([]);
    const [matrixPageData, setMatrixPageData] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [filters, setFilters] = useState({
        searchBar: ''
    })

    useEffect(() => {
        // Update the title for the page
		document.title = "Organisations" +  " - " + props.literals.L22020 + " - " + props.literals.L363;

        setIsFetching(true);
        try
        {
            getOSHData('INTERNATIONAL_ORGANISATIONS')
            .then((res) => {
                // Filter the returned elements so there are no elements with empty values for all the texts
                setMatrixPageData( res.resultset.filter(item => props.literals['L'+item.text1] != "" || props.literals['L'+item.text2] != "" || props.literals['L'+item.text3] != "") );
            })
        }
        catch (error) 
        {
			console.log('Error fetching selector countries:', error)
		} 
        finally 
        {
			setIsFetching(false);
		}
    }, [])

    useEffect(() => {
        setIsFetching(true);
        try {
            getOSHData('INTERNATIONAL_ORGANISATIONS', filters)
            .then((res) => {
                // Filter the returned elements so there are no elements with empty values for all the texts
                setMatrixPageData( res.resultset.filter(item => props.literals['L'+item.text1] != "" || props.literals['L'+item.text2] != "" || props.literals['L'+item.text3] != "") );
            })
        } catch (error) {
            console.log('Error fetching data', error)
        } finally {
            setIsFetching(false);
        }
    }, [filters])

    const handleCallbackSearch = (searchCallback) => {
        setFilters( { searchBar: searchCallback } );
    }

    const onChangePage = (pageOfItems) => {
        setPageOfItems(pageOfItems);
	}

    return (
        <div className='organisations'>
            <AdviceSection literals={ props.literals } section={["osh-infrastructure","international-organisations"]} methodologyData={{section: 'osh-infrastructure', subsection: 'International organisations', indicator: 410}} />

            <section className='container'>
                
                <div className='extra-wrapper'>
                    { /** Filters Component */}
                    <SelectFilters
                        literals={ props.literals }
                        onSearchbarClick={ handleCallbackSearch }
                    />

                    <p className="btn--wrapper text-center">
                        <Link to='/osh-infrastructure/international-programmes' className="btn-default btn-main-color text-center "> { props.literals.L20522 }</Link>
                    </p>
                </div>
                <div className='container'>
                    {/** Cards Component */}
                    <div className='matrix--elements--wrapper'>
                        { pageOfItems.length > 0 ? (
                            pageOfItems.map((data, index) => {
                                const position = matrixPageData.findIndex((matrixData) => matrixData == data);
                                const id = `${index}-${props.literals["L"+data.text1]}-${position}`

                                return <Cards key={ id } idCard={ id } countryData={ data } literals={ props.literals } cardType={ 'organisation' }/>
                            })
                        ) : (<span>{ props.literals.L20706 }</span>)}                            
                    </div>

                    {/* PAGINATION */}
                    <Pagination items={ matrixPageData } onChangePage={ onChangePage } />
                </div>
            </section>

            <Methodology literals={ props.literals } section={ 'International organisations' } />
        </div>
    )
}

Organisations.displayName = 'Organisations';

export default connect(null, null)(Organisations);